import { APP_NAME, PAGE_ID } from '@config';

export const ROUTE_MODE: 'profile' | 'customer' = 'profile';

export const SHOW_APPLE_SIGN_IN = true;

export const ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.mws.cryptosignal';
export const IOS_STORE_URL = 'https://apps.apple.com/app/idTODO';

export const DEV_HOSTS: readonly string[] = ['localhost:8100', 'localhost:8101'];

export const CONTACT_DIALOG_RESHOW_DAYS = 7;

export const CRYPTO_KEY_SOURCE = `${APP_NAME}:${PAGE_ID}`;

export const DEFAULT_TOKENS = [
  'BTC',
  'ETH',
  'SOL',
  'BNB',
  'XRP',
  'ADA',
  'AVAX',
  'DOGE',
  'LINK',
  'MATIC',
] as const;

export const SIGNAL_TYPES = ['LONG', 'SHORT', 'BOI', 'Breakout'] as const;

export const TIMEFRAME_OPTIONS = ['15m', '1h', '4h'] as const;

export function isDevHost(): boolean {
  if (typeof window === 'undefined') return false;
  return DEV_HOSTS.includes(window.location.host);
}

export function profileBasePath(): string {
  return ROUTE_MODE === 'customer' ? '/customer' : '/profile';
}
